import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedModule} from './shared/shared.module';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {NgxSpinnerModule} from 'ngx-spinner';
import {TemplateModule} from './shared/template/template.module';
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FullLayoutComponent} from './layouts/full-layout/full-layout.component';
import {CommonLayoutComponent} from './layouts/common-layout/common-layout.component';
import {CoreModule} from './core';
import {ThemeConstantService} from './shared/services/theme-constant.service';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {AuthInterceptor} from './core/interceptors/auth.interceptor';
import {NotificationInterceptor} from './core/interceptors/notification.interceptor';
import {AuthExpiredInterceptor} from './core/interceptors/auth-expired.interceptor';
import {ErrorHandlerInterceptor} from './core/interceptors/errorhandler.interceptor';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { ExecuteBeforeRequestInterceptor } from './core/interceptors/http.interceptor';
import { NgxsModule } from '@ngxs/store';
import { AppState } from './state/app.state';
import { environment } from 'src/environments/environment';
import { AppsService } from './shared/services/apps.service';
import { AppQueries } from './state';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    CommonLayoutComponent,
    FullLayoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TemplateModule,
    SharedModule,
    NgxSpinnerModule,
    NzBreadCrumbModule,
    NgxWebstorageModule.forRoot({ prefix: 'fmarket', separator: '-' }),
    CoreModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgxsModule.forRoot([
      AppState,
    ], { developmentMode: !environment.production }),
  ],
  providers: [
    AppsService,
    AppQueries,
    ToastrService,
    UploaderService,
    {
      provide: NZ_I18N,
      useValue: en_US,
    },
    ThemeConstantService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExecuteBeforeRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
